
import { ValidationProvider } from 'vee-validate'

export default {
  components: { ValidationProvider },
  props: {
    id: { required: true },
    rules: { type: [String, Object] },
    name: { type: String, required: true },
    value: { type: [String, Boolean] }
  }
}
